import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

const useMergeVendor = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      sourceId,
      targetVendorId,
    }: {
      sourceId: number;
      targetVendorId: number;
    }) => {
      return (await glynt).vendor.mergeVendor(sourceId, targetVendorId);
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendors'],
      });
    },
  });
};

export default useMergeVendor;
